/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargePointChargingProfile } from '../../models/charge-point-charging-profile';

export interface SetChargePointChargingProfile$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected charge point
 */
  chargePointUid: string;

/**
 * The uid of the selected connector or 0 for requesting general chargepoint
 */
  connectorUid: string;
      body: ChargePointChargingProfile
}

export function setChargePointChargingProfile(http: HttpClient, rootUrl: string, params: SetChargePointChargingProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setChargePointChargingProfile.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('chargePointUid', params.chargePointUid, {});
    rb.path('connectorUid', params.connectorUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setChargePointChargingProfile.PATH = '/stations/{uid}/drive/chargepoints/{chargePointUid}/setchargingprofile/{connectorUid}';
